import { getVariant } from '@apia/theme';
import * as React from 'react';
import { Box } from '@apia/theme';

export interface IDialogButtonBar {
  children: React.ReactNode;
  className?: string;
}

export const DialogButtonBar: React.FC<IDialogButtonBar> = ({
  children,
  className,
}) => {
  return (
    <Box
      className={`${className ?? ''} buttonsBar`}
      {...getVariant('layout.common.modals.buttonsBar')}
    >
      {children}
    </Box>
  );
};
